module.exports = __webpack_public_path__ + "static/media/alg-logo.28689643.svg";